function apiBase() {
  const raw =
    process.env.REACT_APP_NODE_API_URL ||
    process.env.REACT_APP_API_URL ||
    '';
  return String(raw).trim().replace(/\/$/, '');
}

/** Turn DB-stored relative paths into full URLs for img/background use. */
export function resolveMediaUrl(value) {
  if (value == null || value === '') return value;
  if (typeof value !== 'string') return value;

  const v = value.trim();
  if (!v || v.startsWith('data:') || v.startsWith('blob:')) return v;
  if (/^https?:\/\//i.test(v) || v.startsWith('//')) return v;
  if (v.startsWith('/static/')) return v;

  const base = apiBase();
  if (!base) return v;

  if (v.startsWith('/uploads/') || v.startsWith('/image/')) {
    return `${base}${v}`;
  }
  if (v.startsWith('/')) {
    return `${base}${v}`;
  }
  if (!v.includes('/') && /\.(png|jpe?g|gif|webp|svg|ico)$/i.test(v)) {
    return `${base}/image/${v}`;
  }
  return v;
}

export default resolveMediaUrl;
